import { type DragApi, type NativeDragApi } from '../types'

export const useDragAndDrop = (dragApi: DragApi): NativeDragApi => {
  return {
    onDragStart: (e: React.DragEvent<HTMLDivElement>) => {
      e.currentTarget.blur()
      const draggedIndex = e.currentTarget.getAttribute('drag-index')
      if (draggedIndex) {
        dragApi.onDragStart(draggedIndex)
      }
    },
    onDragOver: (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault()
    },
    onDragEnter: (e: React.DragEvent<HTMLDivElement>) => {
      e.currentTarget.focus()
      const dropIndex = e.currentTarget.getAttribute('drag-index')
      if (dropIndex) {
        dragApi.onDragEnter(dropIndex)
      }
    },
    onDrop: (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault()
      dragApi.onDrop()
    },
  }
}
